import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import translationEN from "../locales/en/translation.json";
import translationFR from "../locales/fr/translation.json";

import studioEN from "../locales/en/studio.json";
import studioFR from "../locales/fr/studio.json";
import { resources } from "@unique-wool/studio-translations";

import LanguageDetector from "i18next-browser-languagedetector";
import LoggingService from "../service/Logging.service";

// Prevent initialization if i18next was already initialized
if (!i18n.isInitialized) {
  i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
      fallbackLng: "en",
      debug: false,
      saveMissing: true,
      missingKeyHandler: (lngs, ns, key) => {
        LoggingService.flagMissingKey(
          `Missing translation key: "${key}" for language "${lngs[0]}" in environment Frontend - "${process.env.NODE_ENV}"`
        );
      },
      resources: {
        en: {
          translation: {
            ...translationEN,
            ...studioEN,
            ...resources.en,
          },
        },
        fr: {
          translation: {
            ...translationFR,
            ...studioFR,
            ...resources.fr,
          },
        },
      },
      supportedLngs: ["fr", "en"],
      interpolation: {
        escapeValue: false,
      },
    });
}

export default i18n;
